<template>

    <cms-view class="view-logger-create-selection">

        <cms-heading title="Selectie maken" icon="magicon-ok-circle"></cms-heading>
        <cms-panel>
            <div class="add-ean-holder">
                <input class="input-normal" placeholder="Voer het serienummer van een logger in..." v-model.trim="serialNumber" @keydown.enter.prevent="searchLogger(true)" ref="serialNumberInput" />
                <cms-button icon="magicon-plus" color="positive" @click="searchLogger(false)" :disabled="!serialNumber" :loading="fetchingLogger">Toevoegen</cms-button>
            </div>
        </cms-panel>

        <cms-heading :title="loggers.length + ' logger(s) geselecteerd'" level="2"></cms-heading>
        <cms-table-panel :placeholder="!loggers.length" placeholder-text="Nog geen loggers geselecteerd">
            <tr>
                <th>Serienummer</th>
                <th>Type</th>
                <th>Status</th>
                <th>Opmerkingen bij statuswisseling <cms-info-icon v-tooltip="'Wordt opgeslagen bij statuswisseling'" /></th>
                <th></th>
            </tr>
            <tr v-for="logger in loggers">
                <td>{{ logger.serialNumber }}</td>
                <td>{{ logger.type.title }}</td>
                <td><cms-text-label :title="logger.state | loggerState" :color="logger.state | loggerStateColor" /></td>
                <td class="comments">
                    <textarea rows="1" class="textarea-normal" :value="comments[logger.id]" @input="updateComment(logger, $event.target.value)"></textarea>
                </td>
                <td class="actions">
                    <cms-link icon="magicon-minus-circle" v-tooltip="'Verwijder uit selectie'" @click="deleteSelection(logger)"></cms-link>
                </td>
            </tr>
        </cms-table-panel>

        <logger-action-grid :entries="entries" @executed="onActionExecuted"></logger-action-grid>

    </cms-view>

</template>

<script>

    import Component from 'vue-class-component'
    import Vue from 'global-vue'
    import di from 'di'
    import gql from 'graphql-tag'

    import LoggerQueries from 'app/queries/LoggerQueries'

    import without from 'lodash/without'
    import map from 'lodash/map'

    @Component({

        name: 'select-loggers'
    })
    export default class extends Vue
    {
        data(){

            return {

                loggers: [],
                comments: {},
                serialNumber: null,
                fetchingLogger: 0
            }
        }

        created(){

            this.logger = this.$logger.child('SelectLoggers');
        }

        mounted(){

            const selected = di.get('selectedLoggers');

            if(selected){

                this.logger.info(`Importing ${selected.length} selected loggers`);
                this.loggers = selected;

                di.set('selectedLoggers', null);
            }

            this.$refs.serialNumberInput.focus();
        }

        breadcrumb(){

            return 'Selectie maken';
        }

        get entries(){

            return this.loggers.map(logger => ({ logger, comments: this.comments[logger.id] }));
        }

        updateComment(logger, comment){

            this.$set(this.comments, logger.id, comment);
        }

        searchLogger(delay){

            if(this.fetchingLogger || !this.serialNumber){
                return;
            }

            const execute = () => {

                const currentLoggerSerialNumbers = map(this.loggers, 'serialNumber');

                if (currentLoggerSerialNumbers.indexOf(this.serialNumber) !== -1) {

                    this.$toast.warning('De logger met het ingevoerde serienummer is al toegevoegd aan de selectie');
                    return;
                }

                this.fetchingLogger++;

                this.$apollo.query(LoggerQueries.findBySerialNumber({

                    variables: {
                        serialNumber: this.serialNumber
                    }

                })).then(response => {

                    const logger = response.data.viewer.findLoggerBySerialNumber;

                    if (logger) {

                        this.loggers.push(logger);
                        this.serialNumber = null;
                    }
                    else {

                        this.$toast.error('De logger kan niet worden gevonden');
                    }

                    this.fetchingLogger--;

                }).catch(error => {

                    this.logger.error('Error searching logger', error);
                    this.$toast.error('Er ging iets fout bij het zoeken naae de logger');

                    this.fetchingLogger--;
                });
            };

            if(delay){

                setTimeout(execute, 500);
            }
            else {

                execute();
            }
        }

        deleteSelection(logger){

            this.loggers = without(this.loggers, logger);
        }

        onActionExecuted(){

            this.$toast.success('Loggers opgeslagen');
            di.get('apollo').resetStore();

            this.loggers = [];
            this.comments = {};
        }
    }

</script>